import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from '@ex/module/core/services/authentication.service';
import { CrashReportingService } from '@ex/module/core/services/crash-reporting.service';
import { EntityService } from '@ex/module/core/services/entity.service';
import { GeneralService } from '@ex/module/core/services/general.service';
import { LanguageService } from '@ex/module/core/services/language.service';
import { LocalService } from '@ex/module/core/services/local.service';
import { LogService } from '@ex/module/core/services/log.service';
import { PlatformUserService } from '@ex/module/core/services/platform-user.service';
import { TenantService } from '@ex/module/core/services/tenant.service';
import { inOutAnimation } from '@ex/module/shared/animations/allAnimations';
import { ModuleName } from '@ex/module/shared/enums/ModuleName';
import { LanguagePipe } from '@ex/module/shared/pipes/language.pipe';
import { TranslatePipe } from '@ex/module/shared/pipes/translate.pipe';
import { ZenSnackbarService } from '@ex/module/shared/Theme/services/zen-snackbar.service';
import { Subscription } from 'rxjs';
import { first } from 'rxjs/operators';
declare var $: any;
declare const window: any;
@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss'],
  animations: [inOutAnimation]
})
export class ResetPasswordComponent implements OnInit {
  email: string;
  ModuleNames = ModuleName
  password: string;
  confirmPassword: string;
  supportedLanguages: any = [];
  submitted: boolean = false;
  userSubscription: Subscription;
  language: string = 'EN';
  logoLoading: boolean = false;
  tenantLogo: string;
  base64Image: string;
  logoURL: string;
  tenantKeyExists: boolean = false;
  section: string = 'login';
  showLangage
  returnUrl: string;

  token: string;
  isThomas: boolean;

  constructor(
    private authenticationService: AuthenticationService,
    private router: Router, private languagePipe: LanguagePipe,
    private zenSnackBarService: ZenSnackbarService,
    private tenantService: TenantService,
    private platformUserService: PlatformUserService,
    private logService: LogService,
    private route: ActivatedRoute,
    private languageService: LanguageService,
    private crashReportingService: CrashReportingService,
    private localService: LocalService, private translationPipe: TranslatePipe,
    private entityService: EntityService,
    private generalService: GeneralService,
  ) {

  }

  ngOnInit(): void {


    this.token = this.route.snapshot.paramMap.get("id");

    sessionStorage.clear();

    this.canvasStart();
    this.supportedLanguages = this.languageService.supportedLanguages.filter(s => s.key == 'AR' || s.key == 'EN');
    if (window.location.href.includes("thomas-hub"))
      this.isThomas = true;

    if (!this.isThomas)
      this.logoURL = 'assets/img/svg/logo.svg'; // to be resolved to client's logo
    else
      this.logoURL = 'assets/img/svg/thomas-icon.svg'
    let localLanguage = this.localService.getJsonValue('language');
    let sessionLanguage = this.localService.getJsonValue('language');
    if (!localLanguage && !sessionLanguage) {
      this.language = 'EN';
    } else if (localLanguage) {
      this.language = localLanguage;
    } else if (sessionLanguage) {
      this.language = sessionLanguage;
    }



  }

  resetPassword() {

    if (!this.token || !this.password) {
      this.zenSnackBarService.error(this.translationPipe.transform("invalid_reset_token", this.language, this.ModuleNames.Shared) );
      return;
    }

    if (this.password != this.confirmPassword) {
      this.zenSnackBarService.error(this.translationPipe.transform("passwordsDoNotMatch", this.language, this.ModuleNames.Shared));

      return;
    }

    this.platformUserService.resetPassword({
      token: this.token,
      newPassword: this.password
    }).pipe(
      first()
    ).subscribe({
      next: (response) => {
        this.submitted = true;

        // show a message indicating reset success
        this.zenSnackBarService.success(this.translationPipe.transform("reset_password_success", this.language, this.ModuleNames.Common));
        this.router.navigateByUrl("/login")
      },
      error: (error) => {
        this.zenSnackBarService.error(this.translationPipe.transform("reset_password_failed", this.language, this.ModuleNames.Common));
      }
    })

  }



  closeDropdown(menu) {
    if (this[menu]) this[menu] = false;
  }
  canvasStart() {
    var canvas = <HTMLCanvasElement>document.getElementById('c');
    var ctx = canvas.getContext('2d');
    let colors = ['#fbfbfb', '#f7f7f8', '#f4f4f4', '#f0f0f1', '#ededee', '#e9e9ea']
    canvas.height = window.innerHeight;
    canvas.width = window.innerWidth;
    let speed = 1;

    function animate() {
      requestAnimationFrame(animate);
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      for (let color = 0; color < colors.length; color++) {
        ctx.beginPath();
        ctx.moveTo(-200, (canvas.height / 10 + Math.sin(speed * .01) * 200) + color * 100 + color * 100 / 2);
        ctx.bezierCurveTo(
          canvas.width / 2,
          (canvas.height / 4 + Math.cos(speed * .01) * 200) + color * 100 + color * 100 / 2,
          canvas.width / 4,
          (canvas.height / 4 + Math.sin(-speed * .01) * 200) + color * 100 + color * 100 / 2,
          canvas.width + 200,
          (canvas.height / 3 + Math.sin(-speed * .01) * 200) + color * 100 + color * 100 / 2);
        ctx.lineWidth = 130 + color * 100 / 2;
        ctx.strokeStyle = colors[color];
        ctx.stroke();
      }
      speed += .5;
    }

    animate();
  }
  isArabic() {
    if (this.languagePipe.transform(this.language)) {
      $('body').removeClass('ltr');
      $('body').addClass('rtl').attr('dir', 'rtl');
    } else {
      $('body').removeClass('rtl');
      $('body').addClass('ltr').attr('dir', 'ltr');
    }
  }
}
